
export class IUserAccessPermissions {
  admin: string;
  fileUploadPage: string;
  fileDetailsPage: string;
  itemInventoryPage: string;
  canUploadFile: string;
  canSetAppConsent: string;
  canCreateData: string;
  canUpdateData: string;
  canDeleteData: string;
  canReadData: string;
  fileUploadMenu: string;
  fileDetailsMenu: string;
  itemInventoryMenu: string;
}
